<span #cellContent
      class="se-ui-datagrid-date_box"
      [ngStyle]="{'border-bottom' : isInvalid === true ? '2px solid red' : 'initial'}"
      [matTooltipDisabled]="disabled"
      [matTooltip]="tooltipValue">
    {{(value !== null) ? (value | date: viewFormat: "+0000") : "" }}
</span>

<span *ngIf="formGroup" [formGroup]="formGroup">
    <input type="hidden"
           [formControlName]="key"
           [id]="key">
</span>
